import { API_URL, API_USER_URL } from "@/env";
import { message } from "antd";
import { PaymentAdminAPI } from "./type";


const API_USE = API_URL || '';
export interface AdminTransactionParams {
    page?: number;
    per_page?: number;
    code?: string;
}
async function getAdminInvestmentTransactionsList(params: AdminTransactionParams): Promise<PaymentAdminAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.per_page) queryParams.append('per_page', params.per_page.toString());
    if (params.code) queryParams.append('code', params.code);

    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/payment-requests?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });
        if (!response.ok) {
            message.error('Error fetching investment transactions list');
            throw new Error('Failed to fetch investment transactions list');
        }
        const data = await response.json();
        return data as PaymentAdminAPI;
    } catch (error) {
        message.error('Failed to fetch investment transactions list' + (error instanceof Error ? `: ${error.message}` : ''));
        throw error;
    }
}

async function approvePaymentRequest_Admin(id: number, admin_note?: string, received_amount?: number): Promise<any> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/payment-requests/approve/${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                admin_note: admin_note || '',
                received_amount: received_amount || 0
            })
        });
        if (!response.ok) {
            throw new Error('Failed to approve payment request');
        }
        return await response.json();
    } catch (error) {
        console.error('Failed to approve payment request:', error);
        throw error;
    }
}

async function rejectPaymentRequest_Admin(id: number, admin_note: string): Promise<any> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/payment-requests/reject/${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                admin_note: admin_note
            })
        });
        if (!response.ok) {
            throw new Error('Failed to reject payment request');
        }
        return await response.json();
    } catch (error) {
        console.error('Failed to reject payment request:', error);
        throw error;
    }
}

export { getAdminInvestmentTransactionsList , approvePaymentRequest_Admin, rejectPaymentRequest_Admin };